(function() {
    'use strict';
    angular
        .module('liverunApp')
        .factory('Racer', Racer);

    Racer.$inject = ['$resource', 'DateUtils'];

    function Racer ($resource, DateUtils) {
        var resourceUrl =  'api/racers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertDateTimeFromServer(data.date);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.finishDate = DateUtils.convertDateTimeFromServer(data.finishDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
